<template>
    <ordering-table-feature-placeholder
        icon-class="fa fa-tablet"
        title="Bornes"
        description="Cette section préparera la gestion des bornes de commande pour l'établissement. L'interface est visible dans le back-office, mais la fonctionnalité n'est pas encore prête à être utilisée côté client."
        preview-title="Liste des bornes"
        empty-title="Aucune borne disponible"
        empty-description="Aucune borne ne peut encore être configurée ou affichée ici. La gestion des bornes sera activée lorsqu'elle sera prête pour le déploiement client."
        :columns="['Nom', 'Emplacement', 'Statut', 'Dernière activité']" />
</template>

<script>
import OrderingTableFeaturePlaceholder from "./components/OrderingTableFeaturePlaceholder.vue";

export default {
    components: {
        OrderingTableFeaturePlaceholder,
    },
};
</script>
